import React from "react";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

interface IResultConfirmAdjustmentPriceRecord {
  id: number;
  routeName: string;
  status: string;
}

interface ITableResultConfirmAdjustmentPrice {
  records: IResultConfirmAdjustmentPriceRecord[];
}

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    padding: "1rem",
  },
});

const TableResultConfirmAdjustmentPrices = ({
  records,
}: ITableResultConfirmAdjustmentPrice) => {
  const classes = useStyles();

  return (
    <TableContainer>
      <Table size="small" className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Adjustment Price Id</TableCell>
            <TableCell>Route Name</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map(
            (record: IResultConfirmAdjustmentPriceRecord, key: number) => {
              return (
                <TableRow key={`row-${key}`}>
                  <TableCell>{record.id}</TableCell>
                  <TableCell>{record.routeName}</TableCell>
                  <TableCell>{record.status}</TableCell>
                </TableRow>
              );
            },
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableResultConfirmAdjustmentPrices;
